import { render, staticRenderFns } from "./researchForm.vue?vue&type=template&id=6dfdd939&scoped=true"
import script from "./researchForm.vue?vue&type=script&lang=js"
export * from "./researchForm.vue?vue&type=script&lang=js"
import style0 from "./researchForm.vue?vue&type=style&index=0&id=6dfdd939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfdd939",
  null
  
)

export default component.exports